var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.455,
    height: 22.515,
    viewBox: "0 0 25.455 22.515",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f83d77;}.b{fill:#eb1154;}.c{fill:#ff5d8f;}.d{fill:#fff;}.e{fill:#ddf0ff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.717 7.567)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.717 -7.567)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.931,46.44l-8.993-15.05a3.739,3.739,0,0,0-6.42,0L.525,46.44A3.728,3.728,0,0,0,.5,50.2a3.684,3.684,0,0,0,3.24,1.881H21.721a3.684,3.684,0,0,0,3.24-1.881A3.728,3.728,0,0,0,24.931,46.44Z",
    transform: "translate(0 -29.569)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M268.233,50.2a3.684,3.684,0,0,1-3.24,1.881H256V29.57a3.728,3.728,0,0,1,3.21,1.822l8.993,15.05A3.728,3.728,0,0,1,268.233,50.2Z",
    transform: "translate(-243.272 -29.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M32.242,79.127A2.182,2.182,0,0,1,30.3,78a2.225,2.225,0,0,1,.023-2.273l8.985-15.038a2.248,2.248,0,0,1,3.861.01l8.986,15.039A2.22,2.22,0,0,1,52.171,78a2.182,2.182,0,0,1-1.942,1.127H32.242Z",
    transform: "translate(-28.508 -58.105)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M264.992,79.126A2.182,2.182,0,0,0,266.935,78a2.221,2.221,0,0,0-.016-2.261L257.932,60.7A2.249,2.249,0,0,0,256,59.6V79.126Z",
    transform: "translate(-243.271 -58.104)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M228.955,123.557v5.972a1.493,1.493,0,0,1-2.986,0v-5.972a1.493,1.493,0,1,1,2.986,0Z",
    transform: "translate(-214.734 -117.465)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M257.493,123.557v5.972A1.5,1.5,0,0,1,256,131.022v-8.958A1.5,1.5,0,0,1,257.493,123.557Z",
    transform: "translate(-243.272 -117.465)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M213.194,332.278a2.24,2.24,0,1,0,2.24,2.24A2.236,2.236,0,0,0,213.194,332.278Z",
    transform: "translate(-200.466 -317.228)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M258.24,334.517a2.237,2.237,0,0,1-2.24,2.24v-4.479A2.237,2.237,0,0,1,258.24,334.517Z",
    transform: "translate(-243.272 -317.228)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorSmall);
export default __webpack_public_path__ + "static/media/error-small.d3dcc6d077941dafe4f5f761a9b7670e.svg";
export { ForwardRef as ReactComponent };